import Box from '@ilg-totallymoney/ui/components/Box'
import Card from '@ilg-totallymoney/ui/components/Card'
import Flex from '@ilg-totallymoney/ui/components/Flex'
import Heading from '@ilg-totallymoney/ui/components/Heading'
import Text from '@ilg-totallymoney/ui/components/Text'
import Icon from '@ilg-totallymoney/ui/icons/Icon'
import theme from '@ilg-totallymoney/ui/theme'

import { RatesAndFeesContentType } from '@components/RatesAndFees/utils/createRatesAndFeesCardContent'

import {
    StyledRatesAndFeesCardContent,
    StyledTooltipButton,
} from './RatesAndFeesCard.styled'

interface RatesAndFeesCardProps {
    content: RatesAndFeesContentType
    heading: string
    onClick: () => void
}

const RatesAndFeesCard = ({
    content,
    heading,
    onClick,
}: RatesAndFeesCardProps) => (
    <Card hasBorder hasShadow={false} p="space20">
        <Flex
            mb="space20"
            justifyContent="space-between"
            alignItems="center"
            data-testid={heading}
        >
            <Heading variant="20">{heading}</Heading>
            <StyledTooltipButton
                onClick={onClick}
                aria-label={`Opens modal for further details on ${heading} information`}
            >
                <Icon icon="tooltip" color={theme.grey100} size={20} />
            </StyledTooltipButton>
        </Flex>

        <Box>
            {content.map(({ title, value }, i: number) => (
                <StyledRatesAndFeesCardContent
                    justifyContent="space-between"
                    py="space10"
                    gridGap="space20"
                    key={`${title}-${i}`}
                    data-testid={`${heading}-${title}`}
                >
                    <Text variant="80">{title}</Text>

                    <Text variant="80" weight="bold" textAlign="right">
                        {value}
                    </Text>
                </StyledRatesAndFeesCardContent>
            ))}
        </Box>
    </Card>
)

export default RatesAndFeesCard
